<template>
    <div
        v-if="documents.length > 1"
        ref="tabsContainer"
        class="DocumentDetailsTabs"
        :class="{ 'DocumentDetailsTabs--hidden': hidden }"
    >
        <NewButton
            v-for="(document, index) in documents"
            :key="index"
            class="DocumentDetailsTabs__tab"
            :class="{ 'DocumentDetailsTabs__tab--active': currentIndex === index }"
            variant="flat"
            color="neutral"
            @click="handleSelect(index)"
        >
            <span class="DocumentDetailsTabs__tabName" :title="getDocumentName(index)">
                {{ getDocumentName(index) }}
            </span>
        </NewButton>
    </div>
</template>

<style lang="scss">
.DocumentDetailsTabs {
    display: flex;
    overflow: hidden;
    flex: 1;
    min-width: 0;

    &--hidden {
        position: absolute;
        visibility: hidden;
        pointer-events: none;
        // Let tabs expand to natural width for accurate measurement
        flex: none;
        width: auto;
    }

    &__tab {
        display: flex;
        align-items: center;
        padding: 0 20px;
        height: 60px;
        background: transparent;
        border: none;
        border-bottom: 3px solid transparent;
        cursor: pointer;
        white-space: nowrap;
        transition: all 0.2s ease;
        color: var(--eidQualityBlack);
        font-size: 14px;

        &:hover {
            background: var(--eidBgGrayTones-lighter);
        }

        &--active {
            border-bottom-color: var(--eidTrustGreen);
            color: var(--eidTrustGreen);
            font-weight: 500;
            background: var(--eidBgGrayTones-lightest);
        }
    }

    &__tabName {
        display: block;
    }
}
</style>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { VerificationDocument } from '@evidentid/gateway-api-client/src/models/submission-tprm/VerificationDocument.model';

    import NewButton from '@/components/new-button/NewButton.vue';

    @Component({
        emits: [ 'select' ],
        components: {
            NewButton,
        },
    })
    export default class DocumentDetailsTabs extends Vue {
        @Prop({ type: Array, required: true })
        private documents!: VerificationDocument[];

        @Prop({ type: Number, required: true })
        private currentIndex!: number;

        @Prop({ type: Boolean, default: false })
        private hidden!: boolean;

        private getDocumentName(index: number): string {
            return `File ${index + 1}`;
        }

        private handleSelect(index: number): void {
            this.$emit('select', index);
        }
    }
</script>
